import { useQuery } from "@tanstack/react-query"
import { useCustomerContext } from '@unlikelystudio/react-ecommerce-hooks'

import { useWishlistCookie } from "~/hooks/wishlist/useWishlistCookie"
import { getWishlistProfile } from '~/lib/handle-api'
import type { WishlistProfile } from "~/lib/swym/wishlist/types"

export function useWishListInitialChecker() {
  const { wishlistCookie, createWishlistCookie, removeWishlistCookie } = useWishlistCookie()
  const { customerAccessToken } = useCustomerContext()

  return useQuery(
    ["wishListInitialChecker", { customerId: customerAccessToken }],
    async () => {
      if (wishlistCookie) {
        removeWishlistCookie()
      }

      const response: WishlistProfile = await getWishlistProfile({
        accessToken: customerAccessToken,
      })

      if (response.regid && response.sessionid) {
        createWishlistCookie({ regid: response.regid, sessionid: response.sessionid, lid: response.lid })
      }

      return null
    },
    {
      refetchOnMount: false,
      enabled: Boolean(customerAccessToken),
    }
  )
}
